module.exports = __webpack_public_path__ + "assets/images/novibet-logo-mundial.703d379f8d2ec69415ed723aaa549773.png";